import { delay } from '@colonist/utils';
import { ColonistMembershipProduct } from '../../../../../../shared/store/ColonistMembershipProduct.ts';
import { ClientUserState } from '../../../../../shared/scripts/ClientUserState.ts';
import { StorageWrapper } from '../../../../../shared/scripts/StorageWrapper.ts';
import { UISubscriptionOverlayController } from '../../../../../shared/scripts/store/subscription_overlay/UISubscriptionOverlayController.ts';
import { UIMDeviceHandler } from '../../UIMDeviceHandler.ts';
import { UIMSubscriptionOverlayMembershipProductView } from './UIMSubscriptionOverlayMembershipProductView.ts';
const MAX_MEMBERSHIP_REFRESH_ATTEMPTS = 10;
const MEMBERSHIP_REFRESH_INTERVAL_MS = 1000;
export class UIMSubscriptionOverlayController extends UISubscriptionOverlayController {
    createMembershipProductView(membershipProduct) {
        const localizedSubscriptions = UIMSubscriptionOverlayController.getLocalizedSubscriptions();
        const localizedSubscription = localizedSubscriptions.find((data)=>data.subscriptionId == membershipProduct.mobileIAPSKUId);
        const monthlyProduct = ColonistMembershipProduct.getMonthlyProductOfAnnualMembership(membershipProduct.type);
        const localizedMonthlySubscription = monthlyProduct ? localizedSubscriptions.find((data)=>data.subscriptionId == monthlyProduct.mobileIAPSKUId) : undefined;
        return new UIMSubscriptionOverlayMembershipProductView(this.membershipsDiv, this.overlayState, membershipProduct, (purchasedMembershipType)=>this.handleDoubleTapPurchaseSuccess(purchasedMembershipType), localizedSubscription, localizedMonthlySubscription);
    }
    handleDoubleTapPurchaseSuccess(purchasedMembershipType) {
        this.finishSuccessfulPurchase(purchasedMembershipType);
        void UIMSubscriptionOverlayController.reloadAfterMembershipGranted();
    }
    static async reloadAfterMembershipGranted() {
        for(let attempt = 0; attempt < MAX_MEMBERSHIP_REFRESH_ATTEMPTS; attempt++){
            var _ClientUserState_userState;
            await ClientUserState.refresh();
            if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hasMembership()) break;
            await delay(MEMBERSHIP_REFRESH_INTERVAL_MS);
        }
        window.location.reload();
    }
    static getLocalizedSubscriptions() {
        return UIMDeviceHandler.shouldEnableNativePaymentsOnMobile() ? StorageWrapper.getLocalizedStoreSubscriptionData() : [];
    }
    constructor(){
        super();
        this.mainContainer.classList.add('m-store');
        this.bodyContainer.classList.add('m-store-membership');
    }
}
